import { useEffect, useRef } from 'react';
import X from '../../../assets/icons/new_icon/x.svg';

interface Props {
  onClose: any;
}
const CostBranchModal = ({ onClose }: Props) => {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal'
      id='cost_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='cost_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      <div
        className='modal-dialog modal-dialog-centered modal-md'
        role='document'
        ref={modalRef}
      >
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2'>
            <h3 className='newubbemodalheading  mb-0'>
              Cost Centre & Branch Code Combinations
            </h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className='modal-body '>
            <div className='my-0'>
              <table className='table'>
                <thead className=' ubbe-table-header'>
                  <tr className='table-header'>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      style={{ width: '50%' }}
                    >
                      Cost Centre
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      style={{ width: '50%' }}
                    >
                      Branch Code
                    </th>
                  </tr>
                </thead>
                <tbody id='rows' className='legs'>
                  <tr className='align-middle'>
                    <td>210 - Freight Forwarding</td>
                    <td>110 - Inuvik</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>210 - Freight Forwarding</td>
                    <td>127 - Ishop4u</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>210 - Freight Forwarding</td>
                    <td>130 - Freight Forwarding</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>210 - Freight Forwarding</td>
                    <td>131 - ubbe</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>211 - Supply Chain</td>
                    <td>110 - Inuvik</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>211 - Supply Chain</td>
                    <td>125 - Edmonton</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>213 - Procurement of Goods</td>
                    <td>110 - Inuvik</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>213 - Procurement of Goods</td>
                    <td>127 - Ishop4u</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>224 - Distribution Services</td>
                    <td>110 - Inuvik</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>224 - Distribution Services</td>
                    <td>125 - Edmonton</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>224 - Distribution Services</td>
                    <td>127 - Ishop4u</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>224 - Distribution Services</td>
                    <td>131 - ubbe</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>230 - Cargo Handling</td>
                    <td>110 - Inuvik</td>
                  </tr>
                  <tr className='align-middle'>
                    <td>230 - Cargo Handling</td>
                    <td>125 - Edmonton</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostBranchModal;
